module.exports = __webpack_public_path__ + "img/selectPrivateIcon.8c43c668.png";